module.exports = __webpack_public_path__ + "img/evacuvation-sq.96c69047.svg";